import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { PhoneType, TwoFactorAuthenticationMethods } from '@tradingblock/types';
import PrimaryButton from '../components/PrimaryButton';
import { ContextTypes } from '../TwoFactorAuthenticationSetup';
import { CheckboxInput } from '../../fields';
;
const StyledContactInfo = styled.div `
  .contact-change-btn {
    color: ${(params) => (params.context === ContextTypes.login ? 'var(--teal)' : 'var(--blue)')};
  }

  .checklist {
    width: fit-content;
  }
`;
const ContactInfo = ({ contactInfoToDisplay, handleContactInfoUpdate, primaryButtonProps, setPhoneNumberToUseForTwoFactorAuthentication, twoFactorAuthenticationMethodToBeVerified, context, phoneNumberToUseForTwoFactorAuthentication, genericErrorMsg, allowAbilityToCancel, cancelBtnProps, smsTwoFactorAuthenticationMethodVerifiedPhoneData, }) => {
    const [phonesSortedByType, setPhonesSortedByType] = useState([]);
    const [showGenericErrorMsg, setShowGenericErrorMsg] = useState(false);
    useEffect(() => {
        if (twoFactorAuthenticationMethodToBeVerified === TwoFactorAuthenticationMethods.sms) {
            if (typeof contactInfoToDisplay !== 'object') {
                setShowGenericErrorMsg(true);
                return;
            }
            const tempPhonesSortedByType = [];
            const mobilePhoneData = contactInfoToDisplay.find((phoneData) => phoneData.type === PhoneType.Mobile);
            const homePhoneData = contactInfoToDisplay.find((phoneData) => phoneData.type === PhoneType.Home);
            const workPhoneData = contactInfoToDisplay.find((phoneData) => phoneData.type === PhoneType.Work);
            if (mobilePhoneData &&
                (!smsTwoFactorAuthenticationMethodVerifiedPhoneData ||
                    (smsTwoFactorAuthenticationMethodVerifiedPhoneData &&
                        smsTwoFactorAuthenticationMethodVerifiedPhoneData.type !== PhoneType.Mobile &&
                        smsTwoFactorAuthenticationMethodVerifiedPhoneData.phoneNumber !== mobilePhoneData.phoneNumber))) {
                tempPhonesSortedByType.push(mobilePhoneData);
            }
            if (homePhoneData &&
                (!smsTwoFactorAuthenticationMethodVerifiedPhoneData ||
                    (smsTwoFactorAuthenticationMethodVerifiedPhoneData &&
                        smsTwoFactorAuthenticationMethodVerifiedPhoneData.type !== PhoneType.Home &&
                        smsTwoFactorAuthenticationMethodVerifiedPhoneData.phoneNumber !== homePhoneData.phoneNumber))) {
                tempPhonesSortedByType.push(homePhoneData);
            }
            if (workPhoneData &&
                (!smsTwoFactorAuthenticationMethodVerifiedPhoneData ||
                    (smsTwoFactorAuthenticationMethodVerifiedPhoneData &&
                        smsTwoFactorAuthenticationMethodVerifiedPhoneData.type !== PhoneType.Work &&
                        smsTwoFactorAuthenticationMethodVerifiedPhoneData.phoneNumber !== workPhoneData.phoneNumber))) {
                tempPhonesSortedByType.push(workPhoneData);
            }
            setPhonesSortedByType(tempPhonesSortedByType);
        }
    }, []);
    useEffect(() => {
        if (phonesSortedByType.length > 0 && setPhoneNumberToUseForTwoFactorAuthentication) {
            setPhoneNumberToUseForTwoFactorAuthentication(phonesSortedByType[0]);
        }
    }, [phonesSortedByType]);
    const getMainContent = () => {
        if (twoFactorAuthenticationMethodToBeVerified === TwoFactorAuthenticationMethods.email) {
            return (React.createElement(React.Fragment, null,
                React.createElement("p", null, "Let's verify your email."),
                React.createElement("p", null,
                    "We'll email a security code to: ",
                    contactInfoToDisplay),
                React.createElement("p", null,
                    "Need to update the email? Click ",
                    React.createElement("button", { type: "button", className: "contact-change-btn", onClick: handleContactInfoUpdate }, "here"),
                    ".")));
        }
        else if (twoFactorAuthenticationMethodToBeVerified === TwoFactorAuthenticationMethods.sms) {
            if (contactInfoToDisplay.length === 0) {
                return React.createElement("p", null,
                    "You do not have any phone numbers attached to your account. Click ",
                    React.createElement("button", { type: "button", className: "phone-change-btn", onClick: handleContactInfoUpdate }, "here"),
                    " to add one.");
            }
            if (contactInfoToDisplay.length > 0 && phonesSortedByType.length === 0) {
                return React.createElement("p", null,
                    "You have only one phone number or the same phone number listed for your home, work and mobile. This phone number is already verified for two-factor authentication (2FA). If you would like to use another phone number for a two-factor authentication method, please change your home, work or mobile phone number by clicking ",
                    React.createElement("button", { type: "button", className: "phone-change-btn", onClick: handleContactInfoUpdate }, "here"),
                    ".");
            }
            return (React.createElement(React.Fragment, null,
                React.createElement("p", null, "We'll text a security code to a phone number below to verify it."),
                React.createElement("ol", { className: "checklist" }, phoneNumberToUseForTwoFactorAuthentication && phonesSortedByType.map((phoneData) => {
                    if (phoneNumberToUseForTwoFactorAuthentication &&
                        !smsTwoFactorAuthenticationMethodVerifiedPhoneData ||
                        (smsTwoFactorAuthenticationMethodVerifiedPhoneData &&
                            phoneData.type !== smsTwoFactorAuthenticationMethodVerifiedPhoneData.type &&
                            phoneData.phoneNumber !== smsTwoFactorAuthenticationMethodVerifiedPhoneData.phoneNumber)) {
                        return (React.createElement("li", { key: `checklist-option-${phoneData.type}` },
                            React.createElement(CheckboxInput, { id: `${phoneData.phoneNumber}-${phoneData.type}`, checked: phoneNumberToUseForTwoFactorAuthentication && (phoneData.phoneNumber === phoneNumberToUseForTwoFactorAuthentication.phoneNumber && phoneData.type === phoneNumberToUseForTwoFactorAuthentication.type), label: `${phoneData.phoneNumber} (${phoneData.type})`, onchange: () => setPhoneNumberToUseForTwoFactorAuthentication(phoneData) })));
                    }
                })),
                React.createElement("p", null,
                    "Need to update a phone number? Click ",
                    React.createElement("button", { type: "button", className: "contact-change-btn", onClick: handleContactInfoUpdate }, "here"),
                    ".")));
        }
    };
    if (showGenericErrorMsg) {
        return React.createElement("p", { className: "error" }, genericErrorMsg);
    }
    return (React.createElement(StyledContactInfo, { context: context },
        getMainContent(),
        React.createElement("div", { className: "btn-wrapper" },
            allowAbilityToCancel && cancelBtnProps && (React.createElement("button", Object.assign({ type: "button" }, Object.assign({}, cancelBtnProps, { className: `${cancelBtnProps.className ? cancelBtnProps.className : ''} ${(twoFactorAuthenticationMethodToBeVerified !== TwoFactorAuthenticationMethods.sms || (twoFactorAuthenticationMethodToBeVerified === TwoFactorAuthenticationMethods.sms && phonesSortedByType.length > 0)) && 'mr-3'}` })), "Cancel")),
            (twoFactorAuthenticationMethodToBeVerified === TwoFactorAuthenticationMethods.email ||
                (twoFactorAuthenticationMethodToBeVerified === TwoFactorAuthenticationMethods.sms &&
                    phonesSortedByType.length > 0)) && (React.createElement(PrimaryButton, Object.assign({}, primaryButtonProps))))));
};
export default ContactInfo;
//# sourceMappingURL=ContactInfo.js.map